import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { Modal } from '@material-ui/core'
import styled from 'styled-components'

import { FlowStep } from "mobx/Localization/types"
import { useStores } from 'hooks/useStores'

import EditingView from './editing'
import LocalizationFooter from './LocalizationFooter'
import OrderTypeSelection from './steps/OrderTypeSelection'
import AddressSelection from './steps/AddressSelection'
import StoreOnMapSelection from './steps/StoreOnMapSelection'

const ModalContainer = styled.div`
	outline: none;
	position: absolute;
	transform: translate(-50%, -50%);
	left: 50%;
	top: 50%;
	max-width: 1100px;
	min-width: 568px;
	max-height: 80%;
	overflow: hidden;
	margin-top: 0;
	border-radius: var(--borderRadiusFrame);
	background: var(--clear);
	color: var(--strokeMenuTitle);

	@media (max-width: 1024px) {
		height: 100dvh
		width: 100%;
		padding-bottom: 23px;
		position: unset;
		transform: unset;
		left: unset;
		right: unset;
	}
`

const LocalizationModal = () => {
	const [fullHeight, setFullHeight] = useState(false)
	const { localizationStore } = useStores()

	useEffect(() => {
		setFullHeight(localizationStore.currentStep === FlowStep.StoreOnMapSelection)
	}, [localizationStore.currentStep])

	return (
		<Modal open={localizationStore.started} onClose={localizationStore.abort}>
			<ModalContainer data-testid="localization-modal">
				{!localizationStore.currentStep && localizationStore.editing && <EditingView />}

				{localizationStore.currentStep === FlowStep.OrderTypeSelection &&
					<OrderTypeSelection data-testid="order-type-selection" />
				}

				{localizationStore.currentStep === FlowStep.AddressSelection &&
					<AddressSelection />
				}

				{localizationStore.currentStep === FlowStep.StoreOnMapSelection &&
					<StoreOnMapSelection />
				}

				{!fullHeight &&
					<LocalizationFooter />
				}
			</ModalContainer>
		</Modal>
	)
}

export default observer(LocalizationModal)
